import { DatePipe } from "@angular/common";
import { Component, OnInit, TemplateRef, ViewChild, AfterViewInit, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import * as moment from "moment";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Emisor } from "src/app/models/Emisor/Emisor";
import { CertificacionPrecio } from "src/app/models/PlanesUsuario/CertificacionPrecio";
import { EmpresaFacturacion } from "src/app/models/PlanesUsuario/DatosFacturacion";
import { Plan } from "src/app/models/PlanesUsuario/Plan";
import { PlanUsuario } from "src/app/models/PlanesUsuario/PlanUsuario";
import { Resumen } from "src/app/models/PlanesUsuario/Resumen";
import { Sucursal } from "src/app/models/Sucursal";
import { AuthService } from "src/app/modules/auth";
import { ChangeCompanyService } from "src/app/services/changecompany.service";
import { DatosFacturacionService } from "src/app/services/datos-facturacion-service";
import { EmisorService } from "src/app/services/emisor.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { PagoUsuarioService } from "src/app/services/pago-usuario.service";
import { PlanUsuarioService } from "src/app/services/planUsuario.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { UsuarioService } from "src/app/services/usuario.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { VerificacionCertificadoService } from "src/app/services/verificacion-certificado.service";
import { SessionUser } from "src/app/shared/models/sessionUser";
import Swal from "sweetalert2";

@Component({
	selector: "app-dashboard-widgets",
	templateUrl: "./dashboard-widgets.component.html",
	styleUrls: ["./dashboard-widgets.component.scss"],
})
export class DashboardWidgetsComponent implements OnInit, AfterViewInit, OnDestroy  {
	@ViewChild("currentSwal") public currentSwal: SwalComponent;
	public user: SessionUser;
	


	public planSeleccionado: Plan;
	public isReseller: boolean = this.tokenService.userHasReseller();
	@ViewChild("extendPlanForm", { static: true }) extendPlanForm: TemplateRef<any>;
	@ViewChild("changeCompanyForm", { static: true }) changeCompanyForm: TemplateRef<any>;
	public currentEmisorObject: Emisor;
	public emisoresSource: Emisor[];

	public planes: Plan[];
	public datosFacturacion: EmpresaFacturacion;
	public planActual: PlanUsuario;

	public nuevaFechaCaducidad: moment.Moment;
	public fechaActual = moment();
	public certificaciones: CertificacionPrecio[];

	private unsubscribePlan$ = new Subject<void>();
	private unsubscribeEmisor$ = new Subject<void>();
	constructor(
		public utilities: UtilitiesService,

		private changeCompanyService: ChangeCompanyService,
		private localStorage: LocalStorageService,
		private ref: ChangeDetectorRef,
		private tokenService: TokenStorageService,
		public planService: PlanUsuarioService,
		
		public datosFacturacionServicce: DatosFacturacionService,
		private validadorCertificadoService: VerificacionCertificadoService
	) {
		this.user = this.tokenService.getUser() as SessionUser;

		this.emisoresSource = JSON.parse(this.localStorage.getEmisores()) as Emisor[];
		this.currentEmisorObject = this.emisoresSource.find((x) => x.emisorId == this.tokenService.getCompany());
	}

	ngOnInit(): void {
		
		this.planActual = this.changeCompanyService.verifyAlertPayment(this.user.planes, this.emisoresSource.length);
		
		this.changeCompanyService.companyChanged.pipe(takeUntil(this.unsubscribeEmisor$)).subscribe((newEmisor: Emisor) => {
			this.currentEmisorObject = newEmisor;					
		});
	}

	ngOnDestroy(): void {
		// Emitir para desuscribirse de los observables
		this.unsubscribePlan$.next();
		this.unsubscribePlan$.complete();

		this.unsubscribeEmisor$.next();
		this.unsubscribeEmisor$.complete();
	  }
	private async validarCertificado() {
		const validacionCertificado = await this.validadorCertificadoService.validar();
	}

	ngAfterViewInit(): void {
		this.changeCompanyService.planChanged$
        .pipe(takeUntil(this.unsubscribePlan$))
        .subscribe((newPlan: PlanUsuario) => {
            this.planActual = newPlan;
            this.ref.detectChanges();
        });
	}

	
}
